export const PROVINCIACOD = "R";
